import { Paginate } from '@model/Paginate';
import { ProjectHistoric } from '@model/ProjectHistoric';
import { ProjectService } from '@service/project.service';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-project-historics',
  templateUrl: './project-historics.component.html',
  styleUrls: ['./project-historics.component.scss']
})
export class ProjectHistoricsComponent implements OnInit {

  historics: Paginate<ProjectHistoric> = null;

  constructor(
    private route: ActivatedRoute,
    private projectService: ProjectService
  ) { }

  ngOnInit() {
    const id = parseInt(this.route.snapshot.paramMap.get('id'));

    this.projectService.historical(id).subscribe((res: Paginate<ProjectHistoric>) => {
      this.historics = res;
    });
  }

  public get isHistoricsEmpty(): boolean {
    return this.historics === null || this.historics.data.length == 0;
  }
}
